import React from "react";
import LgvCheckboxField from "../../../components/LgvCheckboxField";
import LgvCheckboxGroup from "../../../components/LgvCheckboxGroup";
import { QuestionItem } from "../../../types/form";
import {
  coerceToCheckboxArray,
  normalizeQuestionCheckboxOptions,
} from "../../../utils/checkboxOptions";

interface CheckboxFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
  onOpenHintsWithHint?: (
    hint: { title?: string; content: string } | null,
  ) => void;
}

const CheckboxFieldRenderer: React.FC<CheckboxFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
  onOpenHintsWithHint,
}) => {
  if (question.options && question.options.length > 0) {
    return (
      <LgvCheckboxGroup
        name={inputName}
        value={coerceToCheckboxArray(currentValue)}
        options={normalizeQuestionCheckboxOptions(question.options)}
        disabled={readOnly}
        onChange={(value) =>
          setFormData((prev) => ({
            ...prev,
            [inputName]: value,
          }))
        }
        onOptionHintClick={
          onOpenHintsWithHint
            ? (hint) => onOpenHintsWithHint(hint)
            : undefined
        }
      />
    );
  }

  return (
    <LgvCheckboxField
      id={inputName}
      name={inputName}
      checked={Boolean(currentValue)}
      disabled={readOnly}
      label={question.label || question.questionText || "Yes"}
      onChange={(checked) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: checked,
        }))
      }
    />
  );
};

export default CheckboxFieldRenderer;
